import validateConfig from "../validateConfig";
import getCustomerConsentRequestUrl from "./getCustomerConsentRequestUrl";
const setCustomerConsent = async (params) => {
    const { asosWebRequest, authClient, baseUrl, xSiteOrigin, config, country, consentStatus, } = params;
    validateConfig(config);
    const url = getCustomerConsentRequestUrl({
        baseUrl,
        xSiteOrigin,
    });
    const body = {
        country,
        consentStatus,
    };
    await asosWebRequest.patch({
        url,
        body,
        headers: {
            Authorization: await authClient.getAuthHeader(),
            "Content-Type": "application/json",
        },
    });
    await authClient.refreshToken();
};
export default setCustomerConsent;
